import React from 'react'
import { ICellRendererParams } from 'ag-grid-enterprise'
import { EnhancedStatementRow } from '../../../../utils/dataEnhancement'

// interface HeadingNameCellRendererProps extends ICellRendererParams<EnhancedStatementRow> {
//   showCalculated?: boolean
//   showInput?: boolean
// }

export const HeadingNameCellRenderer: React.FC<ICellRendererParams<EnhancedStatementRow>> = ({ value }) => {
  return <div>{value}</div>
}
